import { GetStaticProps, NextPage } from "next"
import { loadStaticProps, Component, PageProps } from "@/pages-shared/listing"

const Page: NextPage<PageProps> = (props) => (
  <Component basePath="tooling" title="Tooling" {...props} />
)

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: await loadStaticProps(context, "tooling"),
    revalidate: 24 * 60 * 60,
  }
}

export default Page
